module.exports = __webpack_public_path__ + "img/rockestate_logo.d6e6a6d5.svg";